export default __webpack_public_path__ + "static/media/sign_up.95496be4.svg";